import { render } from "./StorageTest.vue?vue&type=template&id=162e59c2&ts=true"
import script from "./StorageTest.vue?vue&type=script&lang=ts"
export * from "./StorageTest.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__